<script setup lang="ts">
import { Base64 } from 'js-base64'
import { storeToRefs } from 'pinia'
import { sessionNotFound } from '~/composables/useAccessEventHandler'
import { initOidcClient } from '~/plugins/oidc'

const route = useRoute()
const ssoConfigStore = useSSOConfigsStore()
const { ssoConfig } = storeToRefs(ssoConfigStore)

async function login() {
  const oidc = initOidcClient(ssoConfig.value)
  await oidc.signinRedirect({
    state: {
      memberId: Base64.encode(route.params.memberId as string),
      offerId: Base64.encode(route.params.offerId as string),
      redirect: 'false',
    },
  })
}

watch(sessionNotFound, (val) => {
  if (val)
    login()
})
</script>

<template>
  <div />
</template>
